import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_PsychiatricAssessment = ({ itemsRef, showErrorFor }) => {

    return <form id='GENERAL_PsychiatricAssessment' className='file-pdf-document'>
        <div className='file-template'>

            <p className='w-750'>
                <span className='eleHeader'>Chief Concern:</span>
                <textarea id="txtChiefConcern" name="txtChiefConcern" className="formTextarea add-only"></textarea>

            </p>
            <p className='w-750'>
                <span className='eleHeader'>History of Present Illness:</span>
                <span className='small'>
                    (Onset, Duration, Frequency of Symptoms, Previous Episodes, etc.)
                </span>
                <textarea id="txtPresentIllness" name="txtPresentIllness" className="formTextarea add-only"></textarea>

            </p>

            <p className='w-750'>
                <span className='eleHeader'>HISTORY OF SYMPTOMS: BEHAVIORAL/EMOTIONAL STATUS (INDIVIDUAL)</span>
            </p>
            <span className='small'>Please check all of following that is typical:</span>
            <table>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_1" name="cbSymptoms_1" className="add-only" value="Aggressive" /> Aggressive</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_2" name="cbSymptoms_2" className="add-only" value="Frustrated easily" /> Frustrated easily</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_3" name="cbSymptoms_3" className="add-only" value="Sad/Crying" /> Sad/Crying</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_4" name="cbSymptoms_4" className="add-only" value="Truancy" /> Truancy</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_5" name="cbSymptoms_5" className="add-only" value="Mood Swings" /> Mood Swings</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_6" name="cbSymptoms_6" className="add-only" value="Angry" /> Angry</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_7" name="cbSymptoms_7" className="add-only" value="Anxiety" /> Anxiety</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_8" name="cbSymptoms_8" className="add-only" value="Hallucinations" /> Hallucinations</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_9" name="cbSymptoms_9" className="add-only" value="Head banging" /> Head banging  </td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_10" name="cbSymptoms_10" className="add-only" value="Fearful" /> Fearful</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_11" name="cbSymptoms_11" className="add-only" value="PTSD" /> PTSD</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_12" name="cbSymptoms_12" className="add-only" value="Lies frequently" /> Lies frequently</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_13" name="cbSymptoms_13" className="add-only" value="Set fires" /> Set fires </td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_14" name="cbSymptoms_14" className="add-only" value="Hurts animals" /> Hurts animals</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_15" name="cbSymptoms_15" className="add-only" value="Avoids adults" /> Avoids adults</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_16" name="cbSymptoms_16" className="add-only" value="Loner" /> Loner</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_17" name="cbSymptoms_17" className="add-only" value="Imaginary friends" /> Imaginary friends</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_18" name="cbSymptoms_18" className="add-only" value="Sexual acting out" /> Sexual acting out</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_19" name="cbSymptoms_19" className="add-only" value="Bedwetting" /> Bedwetting</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_20" name="cbSymptoms_20" className="add-only" value="Impulsive" /> Impulsive</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_21" name="cbSymptoms_21" className="add-only" value="Short attention span" /> Short attention span</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_22" name="cbSymptoms_22" className="add-only" value="Bizarre behavior" /> Bizarre behavior</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_23" name="cbSymptoms_23" className="add-only" value="Irritable" /> Irritable</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_24" name="cbSymptoms_24" className="add-only" value="Running Away" /> Running Away</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_25" name="cbSymptoms_25" className="add-only" value="Hygiene/ADLs" /> Hygiene/ADLs   </td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_26" name="cbSymptoms_26" className="add-only" value="Speech problems" /> Speech problems</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_27" name="cbSymptoms_27" className="add-only" value="Careless reckless" /> Careless, reckless</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_28" name="cbSymptoms_28" className="add-only" value="Bullies threatens" /> Bullies, threatens </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_29" name="cbSymptoms_29" className="add-only" value="Learning problems" /> Learning problems  </td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_30" name="cbSymptoms_30" className="add-only" value="Steals" /> Steals</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_31" name="cbSymptoms_31" className="add-only" value="Suicidal threats" /> Suicidal threats</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_32" name="cbSymptoms_32" className="add-only" value="Low self-esteem" /> Low self-esteem </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_33" name="cbSymptoms_33" className="add-only" value="Hyperactivity" />  Hyperactivity </td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_34" name="cbSymptoms_34" className="add-only" value="Talks back" /> Talks back</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_35" name="cbSymptoms_35" className="add-only" value="Impulse Control" /> Impulse Control</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_36" name="cbSymptoms_36" className="add-only" value="Nightmares" /> Nightmares </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_37" name="cbSymptoms_37" className="add-only" value="Defiant" />  Defiant </td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_38" name="cbSymptoms_38" className="add-only" value="Destructive" /> Destructive</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_39" name="cbSymptoms_39" className="add-only" value="Oppositional" /> Oppositional</td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_40" name="cbSymptoms_40" className="add-only" value="Panic attacks" /> Panic attacks </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_41" name="cbSymptoms_41" className="add-only" value="Drugs dependence" />  Drugs dependence </td>
                    <td className='w-187'><input type="checkbox" id="cbSymptoms_42" name="cbSymptoms_42" className="add-only" value="Phobias" /> Phobias</td>
                    <td className='w-375'><input type="checkbox" id="cbSymptoms_43" name="cbSymptoms_43" className="add-only" value="Loss of Energy/Interests" /> Loss of Energy/Interests</td>
                     
                </tr>
                <tr>
                    <td className='w-750'><input type="checkbox" id="cbSymptoms_44" name="cbSymptoms_44" className="add-only" value="Other Concerns" /> Other Concerns (specify): </td>
                </tr>
            </table>
            <p className='w-750'>
                <textarea id="txtOther" name="txtOther" className="add-only formTextarea"></textarea>

            </p>
            <h5>MEDICATION HISTORY:</h5>

            <table>
                <tr>
                    <td className='w-750'>
                        <input type="checkbox" id="cbMedicationHistory" name="cbMedicationHistory" className="add-only" value="None reported" /> None reported
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><span className='eleHeader'>MEDICATION</span></td>
                    <td className='w-187'><span className='eleHeader'>DOSAGE</span></td>
                    <td className='w-187'><span className='eleHeader'>DATE START/ LAST USE</span></td>
                    <td className='w-187'>
                        <span className='eleHeader'>COMPLIANT</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_1" name="txtMedication_1" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_1" name="txtDosage_1" className="add-only" />

                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_1" name="txtDateStart_1" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_1" name="txtCompliant_1" className="add-only" />

                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By:
                        &nbsp;
                        <input type="radio" id="rbRxSource_1_Ex" name="rbRxSource_1" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_1_In" name="rbRxSource_1" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_2" name="txtMedication_2" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_2" name="txtDosage_2" className="add-only" />

                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_2" name="txtDateStart_2" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_2" name="txtCompliant_2" className="add-only" />

                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_2_Ex" name="rbRxSource_2" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_2_In" name="rbRxSource_2" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_3" name="txtMedication_3" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_3" name="txtDosage_3" className="add-only" />

                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_3" name="txtDateStart_3" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_3" name="txtCompliant_3" className="add-only" />

                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_3_Ex" name="rbRxSource_3" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_3_In" name="rbRxSource_3" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_4" name="txtMedication_4" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_4" name="txtDosage_4" className="add-only" />

                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_4" name="txtDateStart_4" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_4" name="txtCompliant_4" className="add-only" />

                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_4_Ex" name="rbRxSource_4" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_4_In" name="rbRxSource_4" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr >
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_5" name="txtMedication_5" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_5" name="txtDosage_5" className="add-only" />

                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_5" name="txtDateStart_5" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_5" name="txtCompliant_5" className="add-only" />

                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_5_Ex" name="rbRxSource_5" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_5_In" name="rbRxSource_5" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr >
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_6" name="txtMedication_6" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_6" name="txtDosage_6" className="add-only" />

                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_6" name="txtDateStart_6" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_6" name="txtCompliant_6" className="add-only" />

                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_6_Ex" name="rbRxSource_6" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_6_In" name="rbRxSource_6" className="add-only" value="in" />  Internal Doctor
                    </td>
                </tr >
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_7" name="txtMedication_7" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_7" name="txtDosage_7" className="add-only" />

                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_7" name="txtDateStart_7" className="add-only" />

                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_7" name="txtCompliant_7" className="add-only" />

                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_7_Ex" name="rbRxSource_7" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_7_In" name="rbRxSource_7" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr >
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_8" name="txtMedication_8" className="add-only" />
                        <span className='view-only txtMedication_8'> </span>
                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_8" name="txtDosage_8" className="add-only" />
                        <span className='view-only txtDosage_8'></span>
                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_8" name="txtDateStart_8" className="add-only" />
                        <span className='view-only txtDateStart_8'> </span>
                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_8" name="txtCompliant_8" className="add-only" />
                        <span className='view-only txtCompliant_8'> </span>
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>

                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_8_Ex" name="rbRxSource_8" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_8_In" name="rbRxSource_8" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr >
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_9" name="txtMedication_9" className="add-only" />
                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_9" name="txtDosage_9" className="add-only" />
                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_9" name="txtDateStart_9" className="add-only" />
                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_9" name="txtCompliant_9" className="add-only" />
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_9_Ex" name="rbRxSource_9" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_9_In" name="rbRxSource_9" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr >
                <tr>
                    <td className='w-187'><input type="text" id="txtMedication_10" name="txtMedication_10" className="add-only" />
                    </td>
                    <td className='w-187'><input type="text" id="txtDosage_10" name="txtDosage_10" className="add-only" />
                    </td>
                    <td className='w-187'><input type="date" id="txtDateStart_10" name="txtDateStart_10" className="add-only" />
                    </td>
                    <td className='w-187'><input type="text" id="txtCompliant_10" name="txtCompliant_10" className="add-only" />
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        Prescription Prescribed By: &nbsp;
                        <input type="radio" id="rbRxSource_10_Ex" name="rbRxSource_10" className="add-only" value="ex" /> External Doctor
                        &nbsp; -- OR -- &nbsp;
                        <input type="radio" id="rbRxSource_10_In" name="rbRxSource_10" className="add-only" value="in" /> Internal Doctor
                    </td>
                </tr >
            </table >



            <p className='w-750'>
                <span className='eleHeader'>Assessment:</span>
                <span className='small'>(Strengths, Assets, Formulation)</span>
                <textarea id="txtAssessment" name="txtAssessment" className="formTextarea add-only"></textarea>
            </p>

            <p className='w-750'>
                <span className='eleHeader'>EVALUATION OF RISK TO SELF OR OTHERS:</span>
            </p>
            <table>
                <tr>
                    <td className='w-750'>
                        <span><strong>History of Suicidal/Homicidal Risk: </strong></span>
                        &nbsp;
                        <input type="checkbox" id="cbHomicidalRisk" name="cbHomicidalRisk" className="add-only" value="None reported" /> None reported
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_1" name="cbHomicidalRisk_1" className="add-only" value="Suicidal Ideation" /> Suicidal Ideation </td>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_2" name="cbHomicidalRisk_2" className="add-only" value="Suicidal Attempt" /> Suicidal Attempt </td>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_3" name="cbHomicidalRisk_3" className="add-only" value="Suicidal Threats" /> Suicidal Threats</td>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_4" name="cbHomicidalRisk_4" className="add-only" value="Self Injurious Behavior" /> Self Injurious Behavior</td>
                </tr>
                <tr>
                    <td className='w-750'><input type="checkbox" id="cbHomicidalRisk_5" name="cbHomicidalRisk_5" className="add-only" value="History of Serious Physical Harm to Self" /> History of Serious Physical Harm to Self </td>
                </tr>
            </table>

            <p className='w-750'>
                <span className='eleHeader'>Describe history of risk behaviors: </span>
                <textarea id="txtRiskBehaviors" name="txtRiskBehaviors" className="add-only "></textarea>
            </p>

            <table>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_6" name="cbHomicidalRisk_6" className="add-only" value="Homicidal Ideation" /> Homicidal Ideation </td>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_7" name="cbHomicidalRisk_7" className="add-only" value="Homicidal Attempts" /> Homicidal Attempts </td>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_8" name="cbHomicidalRisk_8" className="add-only" value="Homicidal Threats" /> Homicidal Threats</td>
                    <td className='w-187'><input type="checkbox" id="cbHomicidalRisk_9" name="cbHomicidalRisk_9" className="add-only" value="Serious Lethal Intent" /> Serious Lethal Intent</td>
                </tr>
                <tr>
                    <td className='w-750'><input type="checkbox" id="cbHomicidalRisk_10" name="cbHomicidalRisk_10" className="add-only" value="History of Serious Physical Harm to others While in Treatment" /> History of Serious Physical Harm to others While in Treatment</td>
                </tr>
            </table>

            <p className='w-750'>
                <span className='eleHeader'>Describe history of risk behaviors: </span>
                <textarea id="txtDescribeHistory" name="txtDescribeHistory" className="add-only "></textarea>
            </p>

            <table>
                <tr>
                    <td className='w-250'><input type="checkbox" id="cbHomicidalRisk_11" name="cbHomicidalRisk_11" className="add-only" value="Persistent/Repetitive" /> Persistent/Repetitive </td>
                    <td className='w-250'><input type="checkbox" id="cbHomicidalRisk_12" name="cbHomicidalRisk_12" className="add-only" value="Has a Plan" /> Has a Plan </td>
                    <td className='w-250'><input type="checkbox" id="cbHomicidalRisk_13" name="cbHomicidalRisk_13" className="add-only" value="Delusional/Psychotic in Content" /> Delusional/Psychotic in Content</td>
                </tr>
            </table>
            <p className='w-750'>
                <span className='eleHeader'>Summary of Risk Evaluation:</span>

            </p>

            <table>
                <tr>
                    <td className='w-125'>
                        <span><strong>Suicidal Risk is: </strong></span>
                    </td>
                    <td className='w-500'>
                        <input type="radio" id="rbSuicidal_Low" name="rbSuicidal" className="add-only" value="Low to None" /> Low to None &nbsp;
                        <input type="radio" id="rbSuicidal_Moderate" name="rbSuicidal" className="add-only" value="Moderate" /> Moderate &nbsp;
                        <input type="radio" id="rbSuicidal_Imminent" name="rbSuicidal" className="add-only" value="Imminent" /> Imminent
                    </td>
                </tr>
                <tr>
                    <td className='w-125'>
                        <span><strong>Homicidal Risk is: </strong></span>
                    </td>
                    <td className='w-500'>
                        <input type="radio" id="rbHomicidal_Low" name="rbHomicidal" className="add-only" value="Low to None" /> Low to None &nbsp;
                        <input type="radio" id="rbHomicidal_Moderate" name="rbHomicidal" className="add-only" value="Moderate" /> Moderate &nbsp;
                        <input type="radio" id="rbHomicidal_Imminent" name="rbHomicidal" className="add-only" value="Imminent" /> Imminent
                    </td>
                </tr>
            </table>

            <p className='w-750'>
                <span className='eleHeader'>Plan for Work Up and Treatment:</span>
                <span className='small'>
                    (Rx's, Services, Drug Screens, Standing Orders, etc.)</span>
                <textarea id="txtWorkUpTreatment" name="txtWorkUpTreatment" className=" add-only"></textarea>
            </p>

            <p className='w-750'>

                <h3>BEHAVIOR OBSERVATIONS: (FACE-TO-FACE)</h3>

            </p>


            <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'> Mental Status: </span> </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbMentalStatus_1" name="cbMentalStatus_1" className="add-only" value="Alert" /> Alert
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbMentalStatus_2" name="cbMentalStatus_2" className="add-only" value="Oriented to" /> Oriented to:
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbMentalStatus_3" name="cbMentalStatus_3" className="add-only" value="Person" /> Person
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbMentalStatus_4" name="cbMentalStatus_4" className="add-only" value="Alert" /> Alert
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbMentalStatus_5" name="cbMentalStatus_5" className="add-only" value="Oriented to" /> Oriented to:
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbMentalStatus_6" name="cbMentalStatus_6" className="add-only" value="Person" /> Person
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>  <span className='eleHeader'> Appearance:</span></td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className="add-only" value="Neat/Well Groomed" /> Neat/Well Groomed
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className="add-only" value="Disheveled" /> Disheveled
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAppearance_3" name="cbAppearance_3" className="add-only" value="Bizarre" /> Bizarre
                    </td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAppearance_4" name="cbAppearance_4" className="add-only" value="Casual" /> Casual
                    </td>
                    <td className='w-250'>
                        <input type="checkbox" id="cbAppearance_5" name="cbAppearance_5" className="add-only" value="Age Appropriate" /> Age Appropriate
                    </td>
                    <td className='w-250'>&nbsp;</td>
                </tr>
                <tr>
                    <td className='w-750'> <span className='eleHeader'> Hygiene:</span><span><strong> </strong></span></td>
                </tr>
                <tr>
                    <td className='w-250'>
                        <input type="radio" id="rbHygiene_Good" name="rbHygiene" className="add-only" value="Good" /> Good
                    </td>
                    <td className='w-250'>
                        <input type="radio" id="rbHygiene_Fair" name="rbHygiene" className="add-only" value="Fair" /> Fair
                    </td>
                    <td className='w-250'>
                        <input type="radio" id="rbHygiene_Poor" name="rbHygiene" className="add-only" value="Poor" /> Poor
                    </td>
                </tr>
            </table>
            <table>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'> Posture:</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbPosture_1" name="cbPosture_1" className="add-only" value="Relaxed" /> Relaxed </td>
                    <td className='w-187'><input type="checkbox" id="cbPosture_2" name="cbPosture_2" className="add-only" value="Erect" /> Erect </td>
                    <td className='w-187'><input type="checkbox" id="cbPosture_3" name="cbPosture_3" className="add-only" value="Slouched" /> Slouched</td>
                    <td className='w-187'><input type="checkbox" id="cbPosture_4" name="cbPosture_4" className="add-only" value="Pacing" /> Pacing</td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'> Eye Contact:</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbEyeContact_1" name="cbEyeContact_1" className="add-only" value="Appropriate" /> Appropriate </td>
                    <td className='w-187'><input type="checkbox" id="cbEyeContact_2" name="cbEyeContact_2" className="add-only" value="Poor" /> Poor </td>
                    <td className='w-187'> &nbsp; </td>
                    <td className='w-187'> &nbsp; </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'> Primary Facial Expression:</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbPrimaryFacial_1" name="cbPrimaryFacial_1" className="add-only" value="Appropriate" /> Appropriate </td>
                    <td className='w-187'><input type="checkbox" id="cbPrimaryFacial_2" name="cbPrimaryFacial_2" className="add-only" value="Sad" /> Sad </td>
                    <td className='w-187'><input type="checkbox" id="cbPrimaryFacial_3" name="cbPrimaryFacial_3" className="add-only" value="Happy" /> Happy</td>
                    <td className='w-187'><input type="checkbox" id="cbPrimaryFacial_4" name="cbPrimaryFacial_4" className="add-only" value="Elated" /> Elated</td>
                </tr>
                <tr>
                    <td className='w-750'><input type="checkbox" id="cbPrimaryFacial_5" name="cbPrimaryFacial_5" className="add-only" value="Worried" /> Worried</td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'> Affect:</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbAffect_1" name="cbAffect_1" className="add-only" value="Calm" /> Calm </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_2" name="cbAffect_2" className="add-only" value="Optimistic" /> Optimistic  </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_3" name="cbAffect_3" className="add-only" value="Cheerful" /> Cheerful</td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_4" name="cbAffect_4" className="add-only" value="Anxious" /> Anxious</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbAffect_5" name="cbAffect_5" className="add-only" value="Pessimistic" /> Pessimistic </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_6" name="cbAffect_6" className="add-only" value="Fearful" /> Fearful  </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_7" name="cbAffect_7" className="add-only" value="Neutral" /> Neutral</td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_8" name="cbAffect_8" className="add-only" value="Blunted" /> Blunted</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbAffect_9" name="cbAffect_9" className="add-only" value="Depressed" /> Depressed </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_10" name="cbAffect_10" className="add-only" value="Tearful" /> Tearful </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_11" name="cbAffect_11" className="add-only" value="Irritable" /> Irritable</td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_12" name="cbAffect_12" className="add-only" value="Flat" /> Flat</td>
                </tr>
                <tr>
                    <td className='w-187'><input type="checkbox" id="cbAffect_13" name="cbAffect_13" className="add-only" value="Angry" /> Angry </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_14" name="cbAffect_14" className="add-only" value="Euphoric" /> Euphoric </td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_15" name="cbAffect_15" className="add-only" value="Elated" /> Elated</td>
                    <td className='w-187'><input type="checkbox" id="cbAffect_16" name="cbAffect_16" className="add-only" value="Labile" /> Labile</td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'> Judgment:</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="radio" id="rbJudgment_Good" name="rbJudgment" className="add-only" value="Good" /> Good
                    </td>
                    <td className='w-187'>
                        <input type="radio" id="rbJudgment_Fair" name="rbJudgment" className="add-only" value="Fair" /> Fair
                    </td>
                    <td className='w-187'>
                        <input type="radio" id="rbJudgment_Poor" name="rbJudgment" className="add-only" value="Poor" /> Poor
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'> Insight:</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-187'>
                        <input type="radio" id="rbInsight_Good" name="rbInsight" className="add-only" value="Good" /> Good
                    </td>
                    <td className='w-187'>
                        <input type="radio" id="rbInsight_Fair" name="rbInsight" className="add-only" value="Fair" /> Fair
                    </td>
                    <td className='w-187'>
                        <input type="radio" id="rbInsight_Poor" name="rbInsight" className="add-only" value="Poor" /> Poor
                    </td>
                </tr>
                <tr>
                    <td className='w-750'>
                        <span className='eleHeader'> Memory:</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-100'>&nbsp;</td>
                    <td className='w-75'>
                        <span >Recent:</span>
                    </td>
                    <td className='w-75'>
                        <input type="radio" id="rbRecent_Good" name="rbRecent" className="add-only" value="Good" /> Good
                    </td>
                    <td className='w-75'>
                        <input type="radio" id="rbRecent_Fair" name="rbRecent" className="add-only" value="Fair" /> Fair
                    </td>
                    <td className='w-75'>
                        <input type="radio" id="rbRecent_Poor" name="rbRecent" className="add-only" value="Poor" /> Poor
                    </td>
                </tr>
                <tr>
                    <td className='w-100'>&nbsp;</td>
                    <td className='w-75'>
                        <span >Remote:</span>
                    </td>
                    <td className='w-75'>
                        <input type="radio" id="rbRemote_Good" name="rbRemote" className="add-only" value="Good" /> Good
                    </td>
                    <td className='w-75'>
                        <input type="radio" id="rbRemote_Fair" name="rbRemote" className="add-only" value="Fair" /> Fair
                    </td>
                    <td className='w-75'>
                        <input type="radio" id="rbRemote_Poor" name="rbRemote" className="add-only" value="Poor" /> Poor
                    </td>
                </tr>
            </table>
            <h4>Diagnosis</h4>
            <table>
                <tr>
                    <td className='w-25'><span className='eleHeader'>#</span></td>
                    <td className='w-500'><span className='eleHeader'>Diagnosis</span></td>
                    <td className='w-225'><span className='eleHeader'>Date</span></td>
                </tr>
                <tr>
                    <td className='w-25'>(1)</td>
                    <td className='w-500'><input type="text" id="txtDSM5Dx_1" name="txtDSM5Dx_1" className="add-only" />
                    </td>
                    <td className='w-225'><input type="date" className="add-only" id="txtDSM5Date_1" name="txtDSM5Date_1" />
                    </td>
                </tr>
                <tr>
                    <td className='w-25'>(2)</td>
                    <td className='w-500'><input type="text" id="txtDSM5Dx_2" name="txtDSM5Dx_2" className="add-only" />
                    </td>
                    <td className='w-225'><input type="date" className="add-only" id="txtDSM5Date_2" name="txtDSM5Date_2" />
                    </td>
                </tr>
                <tr>
                    <td className='w-25'>(3)</td>
                    <td className='w-500'><input type="text" id="txtDSM5Dx_3" name="txtDSM5Dx_3" className="add-only" />
                    </td>
                    <td className='w-225'><input type="date" className="add-only" id="txtDSM5Date_3" name="txtDSM5Date_3" />
                    </td>
                </tr>
                <tr>
                    <td className='w-25'>(4)</td>
                    <td className='w-500'><input type="text" id="txtDSM5Dx_4" name="txtDSM5Dx_4" className="add-only" />
                    </td>
                    <td className='w-225'><input id="txtDSM5Date_4" name="txtDSM5Date_4" type="date" className="add-only" />
                    </td>
                </tr>
                <tr>
                    <td className='w-25'>(5)</td>
                    <td className='w-500'><input type="text" id="txtDSM5Dx_5" name="txtDSM5Dx_5" className="add-only" />
                    </td>
                    <td className='w-225'><input id="txtDSM5Date_5" name="txtDSM5Date_5" type="date" className="add-only" />
                    </td>
                </tr>
            </table>


        </div >
    </form >
}